export enum InputVariant {
  DEFAULT = 'default',
  NUMERIC = 'numeric',
  FLOATING_LABEL = 'floating-label',
  WITH_ICON = 'with-icon',
  FIXED_EMAIL = 'fixed-email'
}
